import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface ModeloGPTResposta {
    modelo: string
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterModeloGPT = async function (
    authorization: string
): Promise<ModeloGPTResposta | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<ModeloGPTResposta>>("respostaIzza/ObterModeloGPT", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ModeloGPTResposta>(response, "ObterModeloGPT")
    } catch (error) {
        RegistrarLogErro(error, "ObterModeloGPT", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const salvarModeloGPT = async function (
    authorization: string,
    modelo: string
): Promise<ModeloGPTResposta | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<ModeloGPTResposta>>(
                "respostaIzza/SalvarModeloGPT",
                { modelo },
                {
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ModeloGPTResposta>(response, "SalvarModeloGPT")
    } catch (error) {
        RegistrarLogErro(error, "SalvarModeloGPT", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
